import { haveFilterQuery, paginator, haveSort } from '../common/auxFun'

const endpointsMutual = {
  LOAD: (filter, sort, limit, skip) =>
    `/v1/settings/mutual${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  BY_ID: (id) => `/v1/settings/mutual/${id}`,
  CREATE: `/v1/settings/mutual/`,
  UPDATE: (id) => `/v1/settings/mutual/${id}`,
  REMOVE: (id) => `/v1/settings/mutual/${id}`,
}

export default endpointsMutual
